module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/view-admins/view-admins.component.scss
// module id = ./src/app/view-admins/view-admins.component.scss
// module chunks = main